import { apiClient } from 'modules/api-client';
import { Button, FormField, Link, TextInput } from 'modules/design-system';
import { type FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessage, LinkWrapper } from '../../containers/index.css';

type Props = {
  defaultEmail?: string;
  locale?: string;
  onSuccess: () => void;
};

export const SendTokenForm = ({
  defaultEmail = '',
  locale = 'fr',
  onSuccess,
}: Props) => {
  const [t] = useTranslation('user');
  const [form, setForm] = useState({ email: defaultEmail });
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!form.email || pending) return;

    setPending(true);
    apiClient.user
      .sendResetToken(form.email.toLowerCase(), locale)
      .then((response) => {
        setPending(false);
        if (response.success) {
          onSuccess();
        } else {
          setError('An error occured, please try again later.');
        }
      })
      .catch((err: Error) => {
        setPending(false);
        setError(err.message);
      });
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '16px',
      }}
    >
      <FormField
        label={t('user.resetPassword.tokenForm.email.label')}
        htmlFor="send_token-email"
      >
        <TextInput
          id="send_token-email"
          name="email"
          value={form.email}
          placeholder={t('user.resetPassword.tokenForm.email.placeholder')}
          onChange={(e) => setForm({ email: e.target.value })}
          required
          autoFocus
          fullWidth
          type="email"
          autoComplete="off"
        />
      </FormField>
      <Button
        block
        variant="outline-primary"
        type="submit"
        disabled={!form.email || pending}
        style={{ marginTop: '8px' }}
      >
        {pending
          ? t('user.resetPassword.tokenForm.submit.loading')
          : t('user.resetPassword.tokenForm.submit.label')}
      </Button>
      <LinkWrapper>
        <Link to="/login">{t('user.resetPassword.tokenForm.navBack')}</Link>
      </LinkWrapper>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </form>
  );
};
